.payments {
    display: grid;
    grid-template-columns: 48px 48px 48px 48px;
    grid-template-rows: 36px 36px 36px 36px;
    gap: 5px;

    .method {
        width: 48px;
        height: 36px;
        overflow: hidden;

        img {
            width: 100%;
            max-width: 100%;
            height: auto;
        }
    }
}
